import React from 'react';
import '../../../../App.css';
import '../SectionF.css';
import SectionF1Cards from './SectionF1Cards';
import Footer from '../../../Footer'

export default function SectionF1() {
    return(
        <>
        <div class = 'cont'>
            <h1 className = 'section-a-title'>Experiment A1: potential divider circuit using a potentiometer</h1>
        </div>
        <SectionF1Cards/>
        <Footer />
        </>
    )
}
